export type GlyphHorizontalBounds = Pick<DOMRect, 'width' | 'x'>;

export const getGlyphHorizontalCenterOffset = (
  bounds: GlyphHorizontalBounds,
  viewportWidth: number,
) => {
  if (!Number.isFinite(bounds.x) || !Number.isFinite(bounds.width) || bounds.width <= 0) {
    return 0;
  }

  return viewportWidth / 2 - (bounds.x + bounds.width / 2);
};
